import { makeStyles } from '@material-ui/core';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes, { object } from 'prop-types';
import businessCardStyle from '../../assets/jss/components/businessCard';
import PRODUCT_DIALOG_MODE from '../../pages/ProductManagement/Consts';
import GridContainer from '../Grid/GridContainer';
import GridItem from '../Grid/GridItem';
import CleanableInput from '../Input/CleanableInput';
import CustomTypography from '../Typography/CustomTypography';

const useStyles = makeStyles(businessCardStyle);

const BusinessCard = ({
    params,
    handleSetBusinessCardParams,
    validateResults,
    MAX_CHAR_LENGTH,
    mode,
    isOrganizer,
    customTextPersonInfo,
    customColorExhibitor,
}) => {
    const intl = useIntl();
    const classes = useStyles(customColorExhibitor);

    const handleInputPostalCode = (valueInput) => {
        handleSetBusinessCardParams('zip_code', valueInput);
        valueInput = valueInput.trim();
        const code = valueInput.substr(0, 3);
        if (code && code.length === 3 && valueInput.length === 7) {
            const pathPostal = process.env.REACT_APP_POSTAL_URL || '';
            fetch(`${pathPostal}/postal/${code}.json`)
            .then((res) => res.json())
            .then((data) => {
                const d = data.find((it) => it[valueInput]);
                handleSetBusinessCardParams('address', d[valueInput][0]);
            }).catch(() => {
                // TODO
            });
        } else {
            handleSetBusinessCardParams('address', '');
        }
    };

    const renderProductInfoRow = (label, isRequired, content) => (
        <GridContainer className={classes.spacing}>
            <GridItem xs={12} sm={4} md={3}>
                <CustomTypography bold required={mode === PRODUCT_DIALOG_MODE.READ ? false : isRequired} customColor={customColorExhibitor?.contents_text_color}>
                    <FormattedMessage id={label} />
                </CustomTypography>
            </GridItem>
            <GridItem xs={12} sm={8} md={9}>
                {content}
            </GridItem>
        </GridContainer>
    );

    return (
        <>
            {/* work_place */}
            {!isOrganizer && renderProductInfoRow(customTextPersonInfo?.field_name?.work_place || 'workplace', true,
                mode === PRODUCT_DIALOG_MODE.READ
                    ? params.work_place
                    : (
                        <GridContainer className={classes.clearPadding}>
                            <GridItem xs={12} sm={6} md={6}>
                                <CleanableInput
                                    classes={{ root: classes.colorTextInput }}
                                    defaultValue={params.work_place}
                                    onChange={(valueInput) => handleSetBusinessCardParams('work_place', valueInput)}
                                    error={!!validateResults.work_place}
                                    helperText={validateResults.work_place
                                        ? intl.formatMessage(
                                            { id: validateResults.work_place.message },
                                            { maxLength: MAX_CHAR_LENGTH },
                                        ) : ''}
                                />
                            </GridItem>
                            <GridItem>
                                <CustomTypography customColor={customColorExhibitor?.contents_text_color}>
                                    {/* {`※${customTextPersonInfo?.field_name?.work_place || '勤務先'}なき場合は「個人」と入力して下さい`} */}
                                    {intl.formatMessage({ id: 'registerViewer.workPlace' }, {
                                        workPlace: intl.formatMessage({ id: 'workplace' }),
                                    })}
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>
                    ))}

            {/* department */}
            {renderProductInfoRow(customTextPersonInfo?.field_name?.department || 'department', false,
                mode === PRODUCT_DIALOG_MODE.READ
                    ? params.department
                    : (
                        <CleanableInput
                            classes={{ root: classes.colorTextInput }}
                            defaultValue={params.department}
                            onChange={(valueInput) => handleSetBusinessCardParams('department', valueInput)}
                            error={!!validateResults.department}
                            helperText={validateResults.department
                                ? intl.formatMessage(
                                    { id: validateResults.department.message },
                                    { maxLength: MAX_CHAR_LENGTH },
                                ) : ''}
                        />
                    ))}

            {/* position */}
            {renderProductInfoRow(customTextPersonInfo?.field_name?.position || 'position', false,
                mode === PRODUCT_DIALOG_MODE.READ
                    ? params.position
                    : (
                        <CleanableInput
                            classes={{ root: classes.colorTextInput }}
                            defaultValue={params.position}
                            onChange={(valueInput) => handleSetBusinessCardParams('position', valueInput)}
                            error={!!validateResults.position}
                            helperText={validateResults.position
                                ? intl.formatMessage(
                                    { id: validateResults.position.message },
                                    { maxLength: MAX_CHAR_LENGTH },
                                ) : ''}
                        />
                    ))}

            {/* first_name + last_name */}
            {renderProductInfoRow(customTextPersonInfo?.field_name?.name || 'name', true,
                mode === PRODUCT_DIALOG_MODE.READ
                    ? `${params.first_name} ${params.last_name}`
                    : (
                        <GridContainer className={classes.clearPadding}>
                            <GridItem xs={6} md={6}>
                                <CustomTypography bold customColor={customColorExhibitor?.contents_text_color}>
                                    <FormattedMessage id="lastName" />
                                </CustomTypography>
                                <CleanableInput
                                    classes={{ root: classes.colorTextInput }}
                                    defaultValue={params.first_name}
                                    onChange={(valueInput) => handleSetBusinessCardParams('first_name', valueInput)}
                                    error={!!validateResults.first_name}
                                    helperText={validateResults.first_name
                                        ? intl.formatMessage(
                                            { id: validateResults.first_name.message },
                                            { maxLength: MAX_CHAR_LENGTH },
                                        ) : ''}
                                />
                            </GridItem>
                            <GridItem xs={6} md={6}>
                                <CustomTypography bold customColor={customColorExhibitor?.contents_text_color}>
                                    <FormattedMessage id="firstName" />
                                </CustomTypography>
                                <CleanableInput
                                    classes={{ root: classes.colorTextInput }}
                                    defaultValue={params.last_name}
                                    onChange={(valueInput) => handleSetBusinessCardParams('last_name', valueInput)}
                                    error={!!validateResults.last_name}
                                    helperText={validateResults.last_name
                                        ? intl.formatMessage(
                                            { id: validateResults.last_name.message },
                                            { maxLength: MAX_CHAR_LENGTH },
                                        ) : ''}
                                />
                            </GridItem>
                        </GridContainer>
                    ))}

            {/* zip_code */}
            {renderProductInfoRow(customTextPersonInfo?.field_name?.zip_code || 'zipCode', true,
                mode === PRODUCT_DIALOG_MODE.READ
                    ? params.zip_code
                    : (
                        <GridContainer className={classes.clearPadding}>
                            <GridItem xs={12} sm={6} md={6}>
                                <CleanableInput
                                    classes={{ root: classes.colorTextInput }}
                                    defaultValue={params.zip_code}
                                    onChange={(valueInput) => handleInputPostalCode(valueInput)}
                                    error={!!validateResults.zip_code}
                                    helperText={validateResults.zip_code
                                        ? intl.formatMessage(
                                            { id: validateResults.zip_code.message },
                                            { maxLength: MAX_CHAR_LENGTH },
                                        ) : ''}
                                />
                            </GridItem>
                            <GridItem>
                                <CustomTypography customColor={customColorExhibitor?.contents_text_color}>
                                    {intl.formatMessage({ id: 'registerViewer.exampleNumber' })}
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>
                    ))}

            {/* address */}
            {renderProductInfoRow(customTextPersonInfo?.field_name?.address || 'address', true,
                mode === PRODUCT_DIALOG_MODE.READ
                    ? params.address
                    : (
                        <CleanableInput
                            classes={{ root: classes.colorTextInput }}
                            defaultValue={params.address}
                            onChange={(valueInput) => handleSetBusinessCardParams('address', valueInput)}
                            error={!!validateResults.address}
                            helperText={validateResults.address
                                ? intl.formatMessage(
                                    { id: validateResults.address.message },
                                    { maxLength: 1000 },
                                ) : ''}
                        />
                    ))}

            {/* phone_number */}
            {renderProductInfoRow(customTextPersonInfo?.field_name?.phone_number || 'phoneNumber', true,
                mode === PRODUCT_DIALOG_MODE.READ
                    ? params.phone_number
                    : (
                        <GridContainer className={classes.clearPadding}>
                            <GridItem xs={12} md={6}>
                                <CleanableInput
                                    classes={{ root: classes.colorTextInput }}
                                    defaultValue={params.phone_number}
                                    onChange={(valueInput) => handleSetBusinessCardParams('phone_number', valueInput)}
                                    error={!!validateResults.phone_number}
                                    helperText={validateResults.phone_number
                                        ? intl.formatMessage(
                                            { id: validateResults.phone_number.message },
                                            { maxLength: MAX_CHAR_LENGTH },
                                        ) : ''}
                                />
                            </GridItem>
                            <GridItem>
                                <CustomTypography customColor={customColorExhibitor?.contents_text_color}>
                                    {intl.formatMessage({ id: 'registerViewer.exampleTel' })}
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>
                    ))}

            {/* fax_number */}
            {renderProductInfoRow(customTextPersonInfo?.field_name?.fax_number || 'faxNumber', false,
                mode === PRODUCT_DIALOG_MODE.READ
                    ? params.fax_number
                    : (
                        <GridContainer className={classes.clearPadding}>
                            <GridItem xs={12} md={6}>
                                <CleanableInput
                                    classes={{ root: classes.colorTextInput }}
                                    defaultValue={params.fax_number}
                                    onChange={(valueInput) => handleSetBusinessCardParams('fax_number', valueInput)}
                                    error={!!validateResults.fax_number}
                                    helperText={validateResults.fax_number
                                        ? intl.formatMessage(
                                            { id: validateResults.fax_number.message },
                                            { maxLength: MAX_CHAR_LENGTH },
                                        ) : ''}
                                />
                            </GridItem>
                            <GridItem>
                                <CustomTypography customColor={customColorExhibitor?.contents_text_color}>
                                    {intl.formatMessage({ id: 'registerViewer.exampleTelTwo' })}
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>
                    ))}

            {/* email_public */}
            {renderProductInfoRow(customTextPersonInfo?.field_name?.business_card_email || 'emailPublic', true,
                mode === PRODUCT_DIALOG_MODE.READ
                    ? params.email_public
                    : (
                        <CleanableInput
                            classes={{ root: classes.colorTextInput }}
                            defaultValue={params.email_public}
                            onChange={(valueInput) => handleSetBusinessCardParams('email_public', valueInput)}
                            error={!!validateResults.email_public}
                            helperText={validateResults.email_public
                                ? intl.formatMessage(
                                    { id: validateResults.email_public.message },
                                    { maxLength: MAX_CHAR_LENGTH },
                                ) : ''}
                        />
                    ))}

            {/* email_notifications */}
            {renderProductInfoRow(customTextPersonInfo?.field_name?.notification_email || 'emailNotifications', true,
                mode === PRODUCT_DIALOG_MODE.READ
                    ? params.email_notifications
                    : (
                        <CleanableInput
                            classes={{ root: classes.colorTextInput }}
                            defaultValue={params.email_notifications}
                            onChange={(valueInput) => handleSetBusinessCardParams('email_notifications', valueInput)}
                            error={!!validateResults.email_notifications}
                            helperText={validateResults.email_notifications
                                ? intl.formatMessage(
                                    { id: validateResults.email_notifications.message },
                                    { maxLength: MAX_CHAR_LENGTH },
                                ) : ''}
                        />
                    ))}
        </>
    );
};

export default BusinessCard;

BusinessCard.defaultProps = {
    MAX_CHAR_LENGTH: 255,
};

BusinessCard.propTypes = {
    params: PropTypes.oneOfType([() => null, object]).isRequired,
    handleSetBusinessCardParams: PropTypes.func.isRequired,
    validateResults: PropTypes.func.isRequired,
    MAX_CHAR_LENGTH: PropTypes.number,
    mode: PropTypes.bool.isRequired,
    isOrganizer: PropTypes.bool.isRequired,
    customTextPersonInfo: PropTypes.oneOfType([() => null, object]).isRequired,
    customColorExhibitor: PropTypes.oneOfType([() => null, object]).isRequired,
};
